// extracted by mini-css-extract-plugin
export default {"socials":"socials__socials__hfG1l","social":"socials__social__GSFS0","rtlSocial":"socials__rtlSocial__OMMkN","icon":"socials__icon__Lf74x","navOpen":"socials__navOpen___36Xc"};